import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import chatify2 from "../../Assets/Projects/chatify2.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify2}
              isBlog={false}
              title=" Final Year project."
              description="Calculating inverse kinematics optimization for manipulator arms based on energy consumption based on 
              energy consumption."
              
              // ghLink="https://github.com/soumyajit4419/Chatify"
              // demoLink="https://chatify-49.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="pet Advertising Website."
              description="A web based applications to give online solution for the customers who wants to advertising their pets on online websites."
             
               ghLink="https://github.com/RajithaSandeera/PAW"
              // demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Food Recipe Mobile Application."
              description="A web based applications to give online solution for the customers who wants to advertising their pets on online websites."
               ghLink="https://github.com/RajithaSandeera/Chef-Rajitha-"
              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Electric Bill Calculator."
              description="A web based applications to give online solution for the customers who wants to advertising their pets on online websites."
               ghLink="https://github.com/RajithaSandeera/Electricity-Bill-Calculator"
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Library Management System"
              description="Build using Spring boot and This project include the one to one, one to many, many to many connection in it."
               ghLink="https://github.com/RajithaSandeera/Electricity-Bill-Calculator"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Yuwathipathi "
              description="A web application build using react, laravel and mysql, This will help to find partner as they wish.This site include the details and they can send their preferences as they wish"
               ghLink="https://github.com/RajithaSandeera/React-project"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Dominant Color Extractor"
              description="We can extractor color of image seperat, Shows the percentage of each and every color."
              ghLink="https://github.com/RajithaSandeera/Dominant-color-Extractor"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
